/**
 *去掉字符串中所有空格(包括中间空格,需要设置第2个参数为:g)
 */
export const trim_space = function(str, is_global) {
        var result;
        result = str.replace(/(^\s+)|(\s+$)/g, "");
        if (is_global.toLowerCase() == "g") {
            result = result.replace(/\s/g, "");
        }
        return result;
    }
    /**
     *替换字符串中短横线
     */
export const trim_underline = function(str) {
    return str.replace(/\-/g, '/');
}